<!--<form-viewer #formViewer
[dataContainerService]='datasetACS'
[formConfig]='formConfig'
></form-viewer>-->

@if (formViewerService.initialized && formViewerService.formGroup) {
  <form autocomplete="off" name='form'
    [formGroup]="formViewerService.formGroup" class="mb-12">
    @if (checkoutData.carnetData) {
      <div id="carnet-riep">
        <div class="fx-row">
          <div class="mr-12 fx-flex">
            <div class="mr-12 fx-flex-20">
              <span matTooltip="Numero carnet" class="train-carnet-number">
                <span><mat-icon class="arr">local_activity</mat-icon> </span>
                <span>{{checkoutData.carnetData.entitlements.id}}</span>
              </span>
            </div>
            <div class="mr-12 text-center fx-flex-50">
              <div><mat-icon class="arr">train</mat-icon>
              <span><strong>{{checkoutData.carnetData.station_from.name}}</strong></span>
              <span> <mat-icon class="arr">keyboard_arrow_right</mat-icon></span>
              <span><strong>{{checkoutData.carnetData.station_to.name}}</strong></span>
            </div>
          </div>
          <div class="mr-12 text-center fx-flex-30">
            <div>
              <span>Biglietti utilizzati: {{checkoutData.carnetData.entitlements.currentUsages}}/{{checkoutData.carnetData.entitlements.maxUsages}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- Allineamento al box dei campi: i div dei campi sono alti 62px ma il box grigio
  e' alto 40px e sta in CIMA (i 22px restanti sono il subscript, sotto). Quindi
  si allinea tutto in alto e si danno a scambio/Ricerca 40px di altezza con il
  contenuto centrato: cosi' l'allineamento non dipende da label e subscript.
  NB: `items-center` (usata prima) non e' definita in nessun foglio di stile. -->
  <div class="fx-row fx-items-start">
    <div class="mr-12 fx-flex-20">
      <form-input-viewer
        [formInputDefinition]='formFields.get("start_station")'
        [formGroup]='formViewerService.formGroup'
        [formControlKey]='formViewerService.controlKeyMap["start_station"]'
        [dataContainerService]='datasetACS'
        [readOnly]="data.mode=='edit-date-time' || checkoutData.carnetData || !enableFormControl.from "
      ></form-input-viewer>
    </div>
    <div class="mr-16 fx-flex-2" style="height:40px; display:flex; align-items:center; justify-content:center">
      <button mat-icon-button (click)="swap()" [disabled]="checkoutData.carnetData"><mat-icon>swap_horiz</mat-icon></button>
    </div>
    <div class="mr-12 fx-flex-20">
      <form-input-viewer
        [formInputDefinition]='formFields.get("end_station")'
        [formGroup]='formViewerService.formGroup'
        [formControlKey]='formViewerService.controlKeyMap["end_station"]'
        [dataContainerService]='datasetACS'
        [readOnly]="data.mode=='edit-date-time' || checkoutData.carnetData || !enableFormControl.to "
      ></form-input-viewer>
    </div>
    <div class="mr-12 fx-flex-12">
      <form-input-viewer
        [formInputDefinition]='formFields.get("date")'
        [formGroup]='formViewerService.formGroup'
        [formControlKey]='formViewerService.controlKeyMap["date"]'
        [dataContainerService]='datasetACS'
        [readOnly]='!enableFormControl.start'
      ></form-input-viewer>
    </div>
    <div class="mr-12 fx-flex-10">
      <form-input-viewer
        [formInputDefinition]='formFields.get("time_d")'
        [formGroup]='formViewerService.formGroup'
        [formControlKey]='formViewerService.controlKeyMap["time_d"]'
        [dataContainerService]='datasetACS'
        [readOnly]='!enableFormControl.start_time'
      ></form-input-viewer>
    </div>
    @if (checkoutData.ar) {
      <div class="mr-12 fx-flex-12">
        <form-input-viewer
          [formInputDefinition]='formFields.get("date_r")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["date_r"]'
          [dataContainerService]='datasetACS'
          [data]='formViewerService.record'
        ></form-input-viewer>
      </div>
    }
    @if (checkoutData.ar) {
      <div class="mr-12 fx-flex-10">
        <form-input-viewer
          [formInputDefinition]='formFields.get("time_r")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["time_r"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
    }
    <div class="mr-12 btn-search fx-flex-5" style="height:40px; display:flex; align-items:center">
      @if (!checkoutData.carnetData) {
        <button mat-flat-button (click)='onSearch()'
          color='accent'
          [disabled]="trnService.loading.getValue()||carnet"
        >{{'Ricerca' | translate}}</button>
      }
      @if (checkoutData.carnetData ) {
        <button mat-flat-button (click)='onSearchCarnet()'
          color='accent'
          [disabled]="trnService.loading.getValue() "
        >{{'Ricerca' | translate}}</button>
      }
    </div>
  </div>
</form>
}
@if (['travel'].includes(checkoutData.mode) && trnService.step.value !== 2) {
  <mat-slide-toggle class="mr-12" (toggleChange)="getCarnet()" [(ngModel)]="carnet">Acquista con carnet</mat-slide-toggle>
}
@if (['travel','edit'].includes(checkoutData.mode) && arShow) {
  <mat-slide-toggle
  (toggleChange)="setAr()" [(ngModel)]="ar" [disabled]="!enableFormControl.ar">Andata / ritorno</mat-slide-toggle>
}
@if (carnet) {
  <div>
    <trenitalia-sale-search-carnet></trenitalia-sale-search-carnet>
  </div>
}